import { render, staticRenderFns } from "./TkScrollToTop.vue?vue&type=template&id=09b4f46b&"
import script from "./TkScrollToTop.vue?vue&type=script&lang=js&"
export * from "./TkScrollToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports